export default __webpack_public_path__ + "static/media/d_escuro.2e3f1534.png";